/* ==========================================================================
   mt-klaviyo-bridge.js — forward Klaviyo onsite form (popup) events to
   GA4, Meta, and Microsoft Clarity.

   Why: the Klaviyo email popup renders via the Klaviyo Shopify app embed,
   outside our theme code. Klaviyo tracks Viewed/Closed/Submitted Form in
   its own account metrics, but nothing reaches GA4/Meta/Clarity — so popup
   signups were invisible in ad attribution and session replay filtering.

   Klaviyo emits a `klaviyoForms` CustomEvent on window for every form
   lifecycle step (https://developers.klaviyo.com/en/docs/javascript_api):
     open / embedOpen / close / redirectedToUrl / submit / stepSubmit

   Routing (mirrors the theme's META RULE — see mt-home.js fireMetaOnce):
     open   → GA4 `mt_popup_open`  + Clarity tag. NOT Meta (engagement
              noise; Meta only gets real conversion signals).
     close  → GA4 `mt_popup_close` + Clarity tag. NOT Meta.
     submit → GA4 `newsletter_signup` (same event name the footer
              newsletter fires, distinguished by `method`) + Meta standard
              `Lead` + Clarity tag.

   Each event fires at most once per browser session per form (sessionStorage
   dedupe, same pattern as mt-home.js `mt_meta_fired`).

   Loaded with `defer` from: mt-v2-head.liquid (home), theme.liquid (both
   branches: policy + Webflow pages), mt-v2-policy.liquid (policies/press).
   Safe everywhere: no DOM dependencies, all sinks guarded with typeof.
   ========================================================================== */
(function () {
  'use strict';

  var STORAGE_KEY = 'mt_kl_bridge_fired';
  var fired = (function () {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}'); }
    catch (e) { return {}; }
  })();

  function once(key, fn) {
    if (fired[key]) return;
    fired[key] = 1;
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(fired)); } catch (e) {}
    fn();
  }

  function toGa4(eventName, params) {
    // Same dual-path as mt-ab.js: direct gtag when present, dataLayer as
    // fallback for GTM-only setups. Shopify's auto GA4 pixel forwards
    // gtag events; it does NOT forward bare dataLayer pushes.
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: eventName }, params));
      }
    } catch (e) {}
  }

  function toClarity(value) {
    try {
      if (typeof window.clarity === 'function') window.clarity('set', 'klaviyo_popup', value);
    } catch (e) {}
  }

  window.addEventListener('klaviyoForms', function (e) {
    var detail = (e && e.detail) || {};
    var formId = detail.formId || 'unknown';

    if (detail.type === 'open') {
      once('open_' + formId, function () {
        toGa4('mt_popup_open', { form_id: formId });
        toClarity('shown');
      });
    } else if (detail.type === 'close') {
      once('close_' + formId, function () {
        toGa4('mt_popup_close', { form_id: formId });
        toClarity('closed');
      });
    } else if (detail.type === 'submit') {
      once('submit_' + formId, function () {
        toGa4('newsletter_signup', { method: 'klaviyo_popup', form_id: formId });
        try {
          if (typeof window.fbq === 'function') {
            window.fbq('track', 'Lead', { content_name: 'klaviyo_popup', content_category: 'newsletter' });
          }
        } catch (err) {}
        toClarity('submitted');
      });
    }
  });
})();
